(function () {
  var state = {
    galleryIndex: 0,
    currentVariantId: null,
    variants: [],
    selectedOptions: [],
    optionNames: []
  };

  function productData() {
    var el = document.getElementById('taeProductRuntimeData');
    if (!el) return {};
    try {
      return JSON.parse(el.textContent || '{}');
    } catch (error) {
      return {};
    }
  }

  function galleryImages() {
    return Array.prototype.map.call(document.querySelectorAll('.tae-gallery-thumb'), function (thumb) {
      return {
        src: thumb.dataset.gallerySrc,
        alt: thumb.dataset.galleryAlt || ''
      };
    }).filter(function (image) {
      return image.src;
    });
  }

  function imageUrlWithWidth(src, width) {
    if (!src) return '';
    if (/([?&])width=\d+/.test(src)) {
      return src.replace(/([?&])width=\d+/, '$1width=' + width);
    }
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }

  function setMainImage(img, src, alt) {
    if (!img || !src) return;
    img.src = src;
    img.srcset = imageUrlWithWidth(src, 400) + ' 400w, ' + imageUrlWithWidth(src, 800) + ' 800w';
    img.alt = alt || '';
  }

  function setImage(index, thumb) {
    var images = galleryImages();
    if (!images.length) return;

    state.galleryIndex = (index + images.length) % images.length;
    var image = images[state.galleryIndex];
    var mainImg = document.getElementById('taeMainImgEl');
    setMainImage(mainImg, image.src, image.alt);
    var zoomImg = document.getElementById('taeZoomImg');
    if (zoomImg) {
      zoomImg.src = imageUrlWithWidth(image.src, 2400);
      zoomImg.alt = image.alt;
    }

    document.querySelectorAll('.tae-gallery-thumb').forEach(function (item) {
      item.classList.remove('active');
    });

    var activeThumb = thumb || document.querySelector('.tae-gallery-thumb[data-gallery-index="' + state.galleryIndex + '"]');
    if (activeThumb) activeThumb.classList.add('active');

    var count = document.getElementById('taeGalleryCount');
    if (count) count.textContent = (state.galleryIndex + 1) + ' / ' + images.length;
  }

  function slideImage(direction) {
    setImage(state.galleryIndex + direction);
  }

  function openZoom() {
    var mainImg = document.getElementById('taeMainImgEl');
    var modal = document.getElementById('taeZoomModal');
    var dialog = document.getElementById('taeZoomDialog');
    var zoomImg = document.getElementById('taeZoomImg');
    if (!mainImg || !modal || !zoomImg) return;

    zoomImg.src = imageUrlWithWidth(mainImg.currentSrc || mainImg.src, 2400);
    zoomImg.alt = mainImg.alt || '';
    if (dialog) dialog.classList.remove('is-zoomed');
    modal.classList.add('active');
    document.documentElement.style.overflow = 'hidden';
  }

  function closeZoom(event) {
    if (event) event.stopPropagation();
    var modal = document.getElementById('taeZoomModal');
    var dialog = document.getElementById('taeZoomDialog');
    if (!modal) return;
    modal.classList.remove('active');
    if (dialog) dialog.classList.remove('is-zoomed');
    document.documentElement.style.overflow = '';
  }

  function toggleZoom(event) {
    if (event) event.stopPropagation();
    var dialog = document.getElementById('taeZoomDialog');
    if (dialog) dialog.classList.toggle('is-zoomed');
  }

  function qty(delta) {
    var el = document.getElementById('taeQtyEl');
    if (!el) return;
    var value = parseInt(el.value, 10) || 1;
    el.value = Math.max(1, Math.min(99, value + delta));
  }

  function resolveVariantId() {
    var input = document.getElementById('taeVariantIdInput');
    var inputId = input ? Number(input.value) : 0;
    var fallbackId = state.variants && state.variants[0] ? Number(state.variants[0].id) : 0;
    var variantId = Number(state.currentVariantId) || inputId || fallbackId;

    if (variantId && input) input.value = String(variantId);
    state.currentVariantId = variantId || state.currentVariantId;
    return variantId;
  }

  function syncVariantInput(variantId) {
    var input = document.getElementById('taeVariantIdInput');
    if (input && variantId) input.value = String(variantId);
  }

  function formatMoney(cents) {
    return 'PKR ' + (cents / 100).toLocaleString('en-PK', { minimumFractionDigits: 0 });
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (char) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      }[char];
    });
  }

  function handleToken(value) {
    return String(value || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  }

  function productHandleFromPath() {
    var match = window.location.pathname.match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  }

  function collectionHandlesForRelated(data) {
    var seen = {};
    var handles = [];

    function add(handle) {
      handle = handleToken(handle);
      if (!handle || seen[handle]) return;
      seen[handle] = true;
      handles.push(handle);
    }

    document.querySelectorAll('a[href*="/collections/"]').forEach(function (link) {
      var match = link.getAttribute('href').match(/\/collections\/([^/?#]+)/);
      if (match) add(match[1]);
    });

    var text = [data.handle, data.title, data.vendor, productHandleFromPath()].join(' ').toLowerCase();
    var vendor = handleToken(data.vendor);

    if (/case|iphone|protector|youksh/.test(text)) {
      add('phone-cases');
      add('mobile-accessories');
      add('baseus');
      add('youksh');
    }
    if (/keyboard|mouse|webcam|splitter|hub|dock|adapter|ugreen/.test(text)) {
      add('computer-accessories');
      add('ugreen');
      add('keyboard-mouse-combo');
    }
    if (/ear|bud|audio|soundpeats|nothing|cmf|anker|oraimo/.test(text)) {
      add('earbuds');
      add('audio-devices');
      add('nothing');
      add('soundpeats');
    }
    if (/watch|black-shark|smartwatch/.test(text)) {
      add('smart-watches');
      add('black-shark');
    }
    if (/charger|gan|power|adapter/.test(text)) {
      add('power-adapters');
      add('power-banks');
      add('charging-cables');
      add('ugreen');
    }
    if (/cable|usb|type-c|lightning|hdmi/.test(text)) {
      add('charging-cables');
      add('computer-accessories');
      add('ugreen');
    }

    add(vendor);
    add('all');
    return handles;
  }

  function imageUrlForProduct(product) {
    if (product.images && product.images.length) return product.images[0].src || product.images[0];
    if (product.featured_image) return product.featured_image;
    return '';
  }

  function relatedCardHtml(product) {
    var price = Number(product.variants && product.variants[0] ? product.variants[0].price : product.price || 0);
    var compare = Number(product.variants && product.variants[0] ? product.variants[0].compare_at_price : product.compare_at_price || 0);
    var save = compare > price ? Math.round(((compare - price) * 100) / compare) : 0;
    var image = imageUrlForProduct(product);
    var imageHtml = image
      ? '<img src="' + escapeHtml(image) + '" alt="' + escapeHtml(product.title) + '" loading="lazy" decoding="async">'
      : '<svg viewBox="0 0 525.5 525.5" aria-hidden="true"><path fill="#f3f5fb" d="M0 0h525.5v525.5H0z"></path><path fill="#c7cfdf" d="M375.5 180.5h-228v165h228zm-210 18h192v89.1l-43.6-43.6-51.3 51.3-28.8-28.8-68.3 68.3zm56 35.5a28.5 28.5 0 1 0 0-57 28.5 28.5 0 0 0 0 57"></path></svg>';

    return [
      '<a href="/products/' + escapeHtml(product.handle) + '" class="tae-prod-card">',
      '<div class="tae-prod-img-wrap">',
      save >= 5 ? '<span class="tae-prod-badge tae-badge-sale">-' + save + '%</span>' : '',
      imageHtml,
      '</div>',
      '<div class="tae-prod-body">',
      '<div class="tae-prod-brand">' + escapeHtml(product.vendor) + '</div>',
      '<div class="tae-prod-title">' + escapeHtml(product.title) + '</div>',
      '<div class="tae-prod-price-row">',
      '<span class="tae-price-now">' + formatMoney(Math.round(price * 100)) + '</span>',
      compare > price ? '<span class="tae-price-was">' + formatMoney(Math.round(compare * 100)) + '</span>' : '',
      save > 0 ? '<span class="tae-price-save">-' + save + '%</span>' : '',
      '</div>',
      '<span class="tae-prod-atc">View Product</span>',
      '</div>',
      '</a>'
    ].join('');
  }

  function hydrateRelatedProducts(data) {
    var grid = document.getElementById('taeRelatedProductsGrid');
    if (!grid || grid.querySelector('.tae-prod-card') || grid.dataset.relatedHydrating) return;

    grid.dataset.relatedHydrating = 'true';
    var currentHandle = data.handle || productHandleFromPath();
    var seen = {};
    var products = [];

    function addProducts(items) {
      (items || []).some(function (product) {
        if (!product || !product.handle || product.handle === currentHandle || seen[product.handle]) return false;
        seen[product.handle] = true;
        products.push(product);
        return products.length >= 8;
      });
    }

    var requests = collectionHandlesForRelated(data).map(function (handle) {
      return fetch('/collections/' + encodeURIComponent(handle) + '/products.json?limit=50')
        .then(function (response) {
          if (!response.ok) return null;
          return response.json();
        })
        .then(function (payload) {
          addProducts(payload && payload.products);
        })
        .catch(function () {});
    });

    Promise.all(requests).then(function () {
      if (!products.length) return;
      grid.innerHTML = products.slice(0, 8).map(relatedCardHtml).join('');
    }).finally(function () {
      grid.dataset.relatedHydrating = '';
    });
  }

  function selectOption(name, value, btn) {
    var optIdx = state.optionNames.indexOf(name);
    if (optIdx > -1) state.selectedOptions[optIdx] = value;

    document.querySelectorAll('.tae-variant-btns').forEach(function (group, groupIndex) {
      if (groupIndex === optIdx) {
        group.querySelectorAll('.tae-variant-btn').forEach(function (button) {
          button.classList.toggle('active', button.textContent.trim() === value);
        });
      }
    });

    var match = state.variants.find(function (variant) {
      return JSON.stringify(variant.options) === JSON.stringify(state.selectedOptions);
    });
    if (!match) return;

    state.currentVariantId = match.id;
    syncVariantInput(match.id);
    var priceEl = document.getElementById('taePriceEl');
    var compareEl = document.getElementById('taeComparePriceEl');
    if (priceEl) priceEl.textContent = formatMoney(match.price);
    if (compareEl && match.compare_at_price > match.price) {
      compareEl.textContent = formatMoney(match.compare_at_price);
      compareEl.style.display = '';
    } else if (compareEl) {
      compareEl.style.display = 'none';
    }
    if (match.featured_image) {
      var variantImg = document.getElementById('taeMainImgEl');
      setMainImage(variantImg, match.featured_image.src, variantImg ? variantImg.alt : '');
    }

    if (btn) btn.classList.add('active');
  }

  function addToCart(event, options) {
    if (event && event.preventDefault) event.preventDefault();

    options = options || {};
    var btn = options.button || document.getElementById('taeAtcBtn');
    var qtyEl = document.getElementById('taeQtyEl');
    var variantId = resolveVariantId();
    if (!btn || !variantId) {
      var form = document.getElementById('taeProductForm');
      if (form && form.submit) form.submit();
      return Promise.reject(new Error('Missing variant id'));
    }

    var originalHtml = btn.innerHTML;
    btn.textContent = 'Adding...';
    btn.style.opacity = '0.7';

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: parseInt(qtyEl && qtyEl.value, 10) || 1 })
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart add failed');
      return response.json();
    }).then(function (item) {
      if (options.redirect) {
        window.location.href = options.redirect;
        return;
      }

      var cartDrawer = document.querySelector('cart-drawer');
      var afterAtc = window.theme && theme.settings && theme.settings.afterAtc;

      if (cartDrawer && afterAtc === 'drawer') {
        // Refresh cart drawer contents then open it (integrates with Enterprise theme drawer)
        cartDrawer.refresh(true).then(function () { cartDrawer.open(); });
      } else {
        // Fallback: manually update cart icon bubble
        fetch('/cart.js').then(function (cartResponse) {
          return cartResponse.ok ? cartResponse.json() : null;
        }).then(function (cart) {
          var bubble = document.getElementById('cart-icon-bubble');
          if (bubble && cart && typeof cart.item_count === 'number') {
            bubble.innerHTML = cart.item_count > 0
              ? '<div class="cart-count-bubble"><span aria-hidden="true">' + cart.item_count + '</span><span class="visually-hidden">' + cart.item_count + ' item(s)</span></div>'
              : '';
          }
        });
      }

      btn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"></polyline></svg> Added!';
      btn.style.background = 'var(--tae-new,#10B981)';
      btn.style.opacity = '1';
      setTimeout(function () {
        btn.innerHTML = originalHtml;
        btn.style.background = '';
      }, 2000);
    }).catch(function () {
      btn.innerHTML = originalHtml;
      btn.style.opacity = '1';
    });
  }

  function buyNow(event) {
    if (event && event.preventDefault) event.preventDefault();
    var btn = document.getElementById('taeBuyNowBtn');
    addToCart(event, {
      button: btn,
      redirect: '/checkout'
    });
  }

  function tab(id, btn) {
    document.querySelectorAll('.tae-tab-panel').forEach(function (panel) {
      panel.classList.remove('active');
    });
    document.querySelectorAll('.tae-tab-btn').forEach(function (button) {
      button.classList.remove('active');
    });
    var panel = document.getElementById('tae-tab-' + id);
    if (panel) panel.classList.add('active');
    if (btn) btn.classList.add('active');
  }

  function relatedSlide(direction) {
    var grid = document.getElementById('taeRelatedProductsGrid');
    if (!grid) return;
    var firstCard = grid.querySelector('.tae-prod-card');
    var cardWidth = firstCard ? firstCard.getBoundingClientRect().width : grid.clientWidth * 0.8;
    var gap = 14;
    grid.scrollBy({ left: direction * (cardWidth + gap), behavior: 'smooth' });
  }

  function init() {
    var data = productData();
    state.currentVariantId = data.currentVariantId || state.currentVariantId;
    state.variants = data.variants || [];
    state.selectedOptions = data.selectedOptions || [];
    state.optionNames = data.optionNames || [];
    syncVariantInput(resolveVariantId());
    hydrateRelatedProducts(data);

    var form = document.getElementById('taeProductForm');
    if (form && !form.dataset.taeSubmitBound) {
      form.dataset.taeSubmitBound = 'true';
      form.addEventListener('submit', addToCart);
    }

    var main = document.getElementById('taeMainImg');
    if (main && !main.dataset.sliderBound) {
      main.dataset.sliderBound = 'true';
      main.addEventListener('click', function (event) {
        if (event.target.closest('button')) return;
        openZoom();
      });
    }

    var modal = document.getElementById('taeZoomModal');
    if (modal && !modal.dataset.zoomBound) {
      modal.dataset.zoomBound = 'true';
      modal.addEventListener('click', closeZoom);
    }

    if (!document.documentElement.dataset.taeZoomKeyBound) {
      document.documentElement.dataset.taeZoomKeyBound = 'true';
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') closeZoom(event);
      });
    }
  }

  window.taeSetImg = setImage;
  window.taeSlideImg = slideImage;
  window.taeOpenZoom = openZoom;
  window.taeCloseZoom = closeZoom;
  window.taeToggleZoom = toggleZoom;
  window.taeQty = qty;
  window.taeSelectOption = selectOption;
  window.taeAddToCart = addToCart;
  window.taeBuyNow = buyNow;
  window.taeTab = tab;
  window.taeRelatedSlide = relatedSlide;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
